var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 343,
    viewBox: "0 0 1440 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_9_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4782 549.882L1438.8 11H22.1883L-3321.01 549.882M1262.51 11L3783.03 553M1086.22 11L2763.07 553M905.734 11L1741.01 553M731.543 11L739.934 553M555.253 11L-298.91 553M378.964 11L-1302.08 553M198.479 11L-2322.04 553M-57.5626 23.9913H1518.55M-162.495 40.6191H1623.48M-292.613 61.9267H1753.6M-477.297 91.0262H1938.29M-735.437 132.599H2196.42M-1125.79 195.477H2586.78M-1818.36 306.683H3289.83M-3342 551.441H4782",
    stroke: "#0BCBFF",
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4782 549.882L1438.8 11H22.1882L-3321.01 549.882M1262.51 11L3783.03 553M1086.22 11L2763.07 553M905.734 11L1741.01 553M731.543 11L739.934 553M555.253 11L-298.91 553M378.964 11L-1302.08 553M198.479 11L-2322.04 553M-57.5625 23.9913H1518.55M-162.495 40.6191H1623.48M-292.613 61.9267H1753.6M-477.297 91.0262H1938.29M-735.437 132.599H2196.42M-1125.79 195.477H2586.78M-1818.36 306.683H3289.83M-3342 551.441H4782",
    stroke: "#0BCBFF",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9_65",
    x: -3352,
    y: 0.5,
    width: 8144.08,
    height: 562.989,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_9_65"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.1e264a5619ef6e85864c2c3523cd1871.svg";
export { ForwardRef as ReactComponent };